<template>
  <div class="box7">
    <div class="titleContent">
      优势二
      <p>课设优</p>
    </div>
    <pageTitle
      title="技能+思维+实战<br/>系统性学习才能具备真正数据分析能力 "
      text="科学设计，理论学习中梳理实践流程，案例实践中培养思维模式!"
      titleColor="#24375C"
      titColor="#86909C"
    />
    <div class="topContent">
      <div class="prize">市场价值</div>
      <div class="content">
        <div class="left"></div>
        <div class="right">
          <div class="item" v-for="i in topList" :key="i.id">
            <p v-html="i.txt"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="subject-box">
      <div class="nav-box">
        <div
          class="nav"
          :class="{ 'cur-nav': cur == index }"
          v-for="(item, index) in list"
          :key="index"
          @click="changeCur(index)"
        >
          {{ item.stage }}
        </div>
      </div>

      <div class="box" @click="show = true">
        <swiper
          :options="swiperOption"
          ref="mySwiper"
          class="swiperitems"
          @slideChange="slideChange()"
        >
          <swiper-slide
            class="swiperwrap"
            v-for="(item, index) in list"
            :key="index"
          >
            <div
              class="wrap"
              :class="[item.stage == '阶段一' ? 'special' : '']"
            >
              <div class="title">
                <p>{{ item.stage }}</p>
                {{ item.name }}
              </div>
              <div class="target">
                <img
                  src="../../../assets/coursePage/dataAnalysis/box7/radar.png"
                  alt=""
                />
                主要内容
              </div>
              <div
                class="module"
                v-for="(item2, index2) in item.module"
                :key="index2"
              >
                <p>{{ item2.p1 }}</p>
                <p>{{ item2.p2 }}</p>
              </div>
              <div class="target">
                <img
                  src="../../../assets/coursePage/dataAnalysis/box7/tips.png"
                  alt=""
                />
                市场价值
              </div>
              <div class="prize">
                {{ item.jiazhi }}
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="btn" @click="openDetail">了解更多</div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import box9 from "./Box9.vue";
import scrollBox from "../common/scrollBox.vue";
import check from "../../../utils/check";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
    box9,
    scrollBox,
  },
  mounted() {},

  data() {
    let that = this;
    return {
      show: false,

      list: [
        {
          stage: "阶段一",
          name: "业务数据分析",
          module: [
            {
              p1: " 模块1：Excel",
              p2: " 数据分析概述、Excel基本操作、Excel公式、Excel函数、常用函数、统计函数、文本函数、日期和时间函数等、Excel图表和使用技巧、Excel数据透视表、Excel零售数据分析案例",
            },
            {
              p1: "模块2：SQL",
              p2: "MySQL数据库基本使用、SQL库操作、SQL表操作、SQL数据操作、索引、事物、SQL案例练习",
            },
            {
              p1: "模块3：BI可视化",
              p2: "Tableau公司和产品介绍、使用Tableau连接多源数据（本地和数据库）、Tableau可视化界面介绍、Tableau数据排序（筛选、计算字段、分层结构、趋势线、预测区间）、初级图表制作（条形图、折线图、饼图、文字云、散点图、地图、树形图、气泡图、图表组合）、高级图表制作（子弹图、环形图、瀑布图、Bump Chart、Table Formatting）、使用Tableau制作仪表板与故事、数据分析报告制作技巧",
            },
          ],

          jiazhi:
            "本阶段匹配职位为初级数据分析师，满足数据运营等岗位用人需求。",
        },
        {
          stage: "阶段二",
          name: "爬虫与数据可视化",
          module: [
            {
              p1: " 模块1：Python基础",
              p2: " Python基础语法、条件控制语句和循环语句、容器类型、函数、文件操作、面向对象、异常处理、模块和包",
            },
            {
              p1: "模块2：爬虫",
              p2: "HTML、CSS、JS入门、爬虫的基本原理、发送请求和网页抓取、数据解析-Xpath、selenium动态渲染页面抓取、pymysql/pymongo保存数据、豆瓣电影爬虫案例、新闻爬虫案例",
            },
            {
              p1: "模块3：可视化工程常用库",
              p2: "数据可视化概述、数据可视化设计基础、canvas绘图与echarts、svg绘图、D3.js及其他可视化组件介绍",
            },
            {
              p1: "模块4：Flask框架",
              p2: "Flask基础、Flask 视图和路由、Flask 模板的基本使用、Flask ORM",
            },
            {
              p1: "阶段综合项目：娱乐数据可视化大屏项目",
              p2: "爬虫、echarts、D3.js、Flask",
            },
          ],
          jiazhi:
            "爬虫和数据可视化是数据分析中的重要技能，本阶段匹配职位为：初中级数据分析师、可视化工程师。",
        },
        {
          stage: "阶段三",
          name: "机器学习与建模分析",
          module: [
            {
              p1: " 模块1：数学和统计学基础",
              p2: "统计学基础、数学基础、检验分析、降维分析",
            },
            {
              p1: "模块2：Python科学计算和可视化库",
              p2: "开发环境（Jupyter Notebook）、科学计算库（Pandas、Numpy）、可视化库（Matplotlib、seaborn）、数据统计分析案例（时间序列分析、路径分析、漏斗分析、归因分析、热力图分析、应用市场探索性数据分析）",
            },
            {
              p1: "模块3：机器学习常用算法",
              p2: "sklearn、Knn、Kmeans、线性回归、逻辑回归、决策树、集成学习、XGBoost、LightGBM、isolationForest、关联规则智能用户运营（RFM分群、流失用户预警）、智能流量运营（异常流量监）、智能活动运营（活动销量预测）",
            },
            {
              p1: "阶段综合项目：金融风控项目",
              p2: "金融风控与反欺诈业务知识、特征工程、逻辑回归评分卡、集成学习评分卡、模型评估与优化、模型融合、不平衡学习与迁移学习、金融风控大赛Top实现方案详解",
            },
          ],

          jiazhi:
            "本阶段匹配职位为：中级数据分析师、机器学习工程师、数据挖掘工程师等。",
        },
        {
          stage: "阶段四",
          name: "大数据分析",
          module: [
            {
              p1: "模块1：Hadoop、Hive、数据仓库",
              p2: "Hadoop、HDFS、YARN、MapReduce、Hive基本原理、Hive的组件、HQL基本操作、Hive分区和分桶",
            },
            {
              p1: "模块2：Spark分布式计算框架和用户画像",
              p2: "Spark-Core、Spark-SQL、Spark-Streaming、Spark-ML",
            },
            {
              p1: "阶段综合项目：推荐系统",
              p2: "推荐系统概述、用户特征和物品特征构建",
            },
          ],

          jiazhi:
            "学后可具备使用Hive、Spark等框架进行大数据分析与挖掘能力。本阶段匹配职位为：数据挖掘工程师、大数据算法工程师等。",
        },
      ],
      topList: [
        {
          id: 11,
          saraly: "15k-20k",
          txt: "掌握Hadoop，Hive等数仓常用框架<br/>掌握数仓在大数据分析场景下的实战技巧<br/>分布式计算框架Spark在大数据分析中的应用<br/>掌握推荐系统常用算法和典型场景下的解决方案",
        },
        {
          id: 12,
          saraly: "11k-15k",
          txt: "能够使用Flask框架搭建数据后台<br/>掌握数据分析常用数学、统计学理论知识<br/>掌握机器学习常见算法 <br/>掌握机器学习在运营、金融风控领域的落地方案",
        },
        {
          id: 13,
          saraly: "5k-11k",
          txt: "掌握爬虫技术爬取所需数据<br/>熟练掌握Echarts、D3.js等可视化技术<br/>掌握Python基本语法<br/>应用Python进行数据清洗，统计分析，数据可视化等操作",
        },
        {
          id: 14,
          saraly: "0k-5k",
          txt: "理解数据分析相关业务知识<br/>掌握数据分析思维方法<br/>熟练数据分析报告的撰写<br/>掌握Excel，Tableau等常用数据分析工具软件的使用<br/>能够掌握SQL语句的增删改查操作<br/>能够应用SQL语句计算常用业务指标",
        },
      ],
      cur: 0,
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 40,
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-box5",
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    openDetail() {
      if (localStorage.getItem(check.getUrlParam("subject"))) {
        window.location.href = localStorage.getItem(
          check.getUrlParam("subject")
        );
      } else {
         this.clickZiXun()
      }
      this.mai("数据开发-就业课","查看更多",0,null)
    },

    changeCur(index) {
      this.swiper.slideTo(index, 0);

      this.cur = index;
    },
    toLink() {
      window.open("https://m.boxuegu.com/");
    },
    slideChange() {
      this.cur = this.$refs.mySwiper.$el.swiper.realIndex;
    },
  },
};
</script>

<style lang="less" scoped>
.box7 {
  padding: 80px 0 0;

  width: 100%;
  background: url("../../../assets/coursePage/dataAnalysis/box7/bgc.png")
    no-repeat;
  background-size: cover;
  .titleContent {
    margin: 0 auto 60px;
    width: 360px;
    height: 80px;
    background: rgba(255, 255, 255, 0.3);
    box-shadow: 0px 4px 20px 0px rgba(202, 211, 235, 0.3),
      inset 2px 2px 2px 0px #ffffff;
    border-radius: 48px;
    backdrop-filter: blur(16px);
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
    display: flex;
    padding: 0 8px 0 48px;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    p {
      width: 176px;
      height: 64px;
      background: linear-gradient(270deg, #8192ff 0%, #a2aeff 100%);
      border-radius: 40px;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 64px;
      text-align: center;
    }
  }
  .topContent {
    padding: 0 32px;
    box-sizing: border-box;
    margin-top: 48px;
    .prize {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #6074ef;
      line-height: 44px;
    }
    .content {
      margin: 12px 0 0 2px;
      display: flex;
      justify-content: space-between;
      .left {
        background: url("../../../assets/coursePage/dataAnalysis/box7/leftImg.png")
          no-repeat;
        background-size: cover;
        width: 69px;
        height: 1228px;
        z-index: 9;
        position: relative;
        flex-shrink: 0;
      }
      .right {
        margin-top: 50px;
        position: relative;
        left: -8px;
        flex: 1;
        .item {
          height: 272px;

          border-radius: 4px;
          border-bottom: 2px dashed #a3b9dd;
          display: flex;
          align-items: center;
          position: relative;
          p:nth-child(2) {
            width: 156px;
            height: 54px;
            background: #8393ff;
            border-radius: 28px;
            border: 2px solid #d4d9ff;
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 54px;
            text-align: center;
            position: absolute;
            right: 4px;
            top: 20px;
          }
          p:nth-child(1) {
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6f7180;
            line-height: 40px;
            margin-left: 20px;
          }
        }

        .item:first-child {
          border-top: 2px dashed #a3b9dd;
          background: url("../../../assets/coursePage/dataAnalysis/box7/itembgc1.png")
            no-repeat;
          background-size: cover;
        }
        .item:nth-child(2) {
          background: url("../../../assets/coursePage/dataAnalysis/box7/itembgc2.png")
            no-repeat;
          background-size: cover;
        }
        .item:nth-child(3) {
          background: url("../../../assets/coursePage/dataAnalysis/box7/itembgc3.png")
            no-repeat;
          background-size: cover;
        }
        .item:nth-child(4) {
          background: url("../../../assets/coursePage/dataAnalysis/box7/itembgc4.png")
            no-repeat;
          background-size: cover;
        }
      }
    }
  }

  .nav-box {
    padding: 0 32px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    margin-top: 32px;
    .nav {
      width: 110px;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 34px;

      text-align: center;
    }

    .cur-nav {
      font-weight: bold;
      color: #5675ff;
      position: relative;
      &::after {
        content: "";
        display: block;
        width: 110px;
        height: 4px;
        background: #5d76ff;
        border-radius: 4px;
        margin-top: 20px;
      }
    }
  }
  .box {
    width: 750px;
    padding-bottom: 36px;
    background: linear-gradient(360deg, #e5e9ff 0%, #bec6fb 100%);
    padding-top: 36px;
    box-sizing: border-box;
    margin-top: -4px;
  }
  .subject-box {
    position: relative;
    margin: 0px auto 0;
    // padding-bottom: 22px;
    width: 100%;
    overflow: hidden;
    .swiperwrap {
      width: 686px;
      height: 1287px;
      background: #ffffff;
      box-shadow: 0px 12px 32px 0px rgba(94, 123, 218, 0.08);
      border-radius: 16px;
      .special {
        .module {
          p:nth-child(2) {
            white-space: normal;
            word-break: break-all;
            word-wrap: break-word;
          }
        }
      }
      .wrap {
        padding: 32px 28px 40px;
        box-sizing: border-box;

        .title {
          display: flex;
          align-items: center;
          margin-bottom: 42px;
          padding-bottom: 28px;
          border-bottom: 1px solid #f2f3f5;
          p {
            width: 96px;
            height: 40px;
            background: rgba(255, 255, 255, 0.8);
            border-radius: 8px;
            border: 2px solid #e4f0ff;
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #4080ff;
            line-height: 40px;
            text-align: center;
            margin-right: 36px;
          }

          font-size: 28px;
          font-family: PingFang SC;
          font-weight: 600;
          color: #4e5969;
        }
        .target {
          margin-top: 48px;
          margin-bottom: 26px;
          display: flex;
          align-items: center;
          img {
            width: 32px;
            height: 32px;
            margin-right: 14px;
          }
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #1d2129;
          line-height: 24px;
          -webkit-background-clip: text;
        }
        .module {
          margin-bottom: 20px;
          p:nth-child(1) {
            font-size: 26px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #4e5969;
            line-height: 44px;
          }
          p:nth-child(2) {
            font-size: 26px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #4e5969;
            line-height: 44px;
          }
        }
        .prize {
          font-size: 26px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #4e5969;
          line-height: 40px;
        }
      }
    }
  }
  .btn {
    width: 686px;
    height: 96px;
    background: linear-gradient(231deg, #6c80fc 0%, #8941fb 100%);
    border-radius: 48px;
    margin: 48px auto 88px;
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 96px;
    text-align: center;
  }
}
</style>
